import { store } from "@store";

class BaseAction {
  constructor(reducer) {
    this.reducer = reducer;
  }

  hasChanged = () =>
    this.getStatePath(store.getState()) !== this.getInitialState();

  data = () => {
    return this.getStatePath(store.getState());
  };

  reset = async () => this.dispatch(this.reducer.initialState);

  getStatePath = (state) => state[this.reducer.getPath()];

  getInitialState = () => this.reducer.initialState;

  dispatch = async (payload) =>
    await store.dispatch(async (dispatch) =>
      dispatch({ type: this.reducer.getActionType(), payload }),
    );
}

export default BaseAction;
